// extracted by mini-css-extract-plugin
export default {"head":"List_head__qFPcI","headMain":"List_headMain__SPf8D","pad0":"List_pad0__9BIyx","id":"List_id__YveL5","btntbl":"List_btntbl__hHV3o","btns":"List_btns__B+5RN"};